// function to be added to OpenLayers.Map.prototype if needed
// 'this' in the function is the map object

// TODO: make this function more flexible...
export const getLayerGroupByName = function (layerName) {
  let mapGroup = this.getLayerGroup(),
      layerArray = mapGroup.getLayers().getArray(),
      foundLayer;

  for (let i = 0, ii = layerArray.length; i < ii; i++) {
    if (layerArray[i].get('layerName') === layerName) {
      foundLayer = layerArray[i];
      break;
    }
  }
  return foundLayer;
}

export default getLayerGroupByName;
